import React, { FC } from 'react'
import { Flex, Icon, IconButton } from '@ui'
import cx from 'classnames'
import css from './imageItem.module.scss'

type ImageItemErrorProps = {
  fileName: string
  onRemove: () => void
}

const ImageItemError: FC<React.PropsWithChildren<ImageItemErrorProps>> = ({
  fileName,
  onRemove,
}) => {
  return (
    <Flex className={cx(css.wrapper, css.wrapper_error)} align="center">
      <div className={cx(css.preview, css.preview_error)}>
        <Icon name="light fa-triangle-exclamation" light={true} />
      </div>
      <div className={css.file}>
        <span className={cx(css.link, css.link_error)}>{fileName}</span>
        <div className={cx(css.uploaded_date, css.uploaded_date_error)}>
          Something is wrong with the file
        </div>
      </div>
      <div className={cx(css.menu, css.menu_error)}>
        <IconButton
          className={cx(css.menu_button, css.menu_button_error)}
          round={false}
          onClick={onRemove}
          tooltip="remove"
          iconName="trash"
        />
      </div>
    </Flex>
  )
}

export default ImageItemError
